import React, { Component } from 'react';
import styled from 'styled-components';

import { Header as H } from 'semantic-ui-react';

import mainVideo from '../../assets/22934935.mp4';
import videoAlt from '../../assets/video-stop.png';
import Video from './components/video';
import Button from './components/callToAction';

const Title = props => (
  <Wrapper>
    <Video mainVideo={mainVideo} videoAlt={videoAlt} />
    <Overlay />
    <Content>
      <ContentText>
        <Header size={props.waypoint} className="hero-header">
          {props.Header}
        </Header>
        <SubHeading size="large" className="hero-subheading">
          {props.Titletag}
        </SubHeading>
        <Button waypoint={props.waypoint} CalltoAction={props.CalltoAction} />
      </ContentText>
    </Content>
  </Wrapper>
);

export default Title;

const Wrapper = styled.div`
  min-height: 80vh;
  min-width: 100%;

  width: 100%;
  height: auto;

  position: relative;
  overflow: hidden;
  @media (max-width: 667px) {
    height: 100vh;
  }
  @media (max-width: 400px) {
    height: 100vh;
  }
`;

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(39, 67, 76, 0.8);
  background: #262936;
  background: linear-gradient(to bottom, rgba(0, 92, 151, 0.2), #262936);
  overflow: hidden;
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  align-items: center;
  @media (max-width: 730px) {
    margin-top: 70px;
    height: 80vh;
  }

  @media (max-width: 400px) {
    height: 90vh;
  }
`;

const ContentText = styled.div`
  width: 70%;
  height: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-width: 1150px) {
    width: 90%;
    height: 50%;
  }
  @media (max-width: 730px) {
    height: 80%;
  }
  @media (max-width: 400px) {
    height: 90%;
    width: 90%;
  }
`;

const Header = styled(H)`
  &.hero-header {
    font-size: 55px !important;
    color: white !important;
    font-weight: 300 !important;
    display: flex !important;
    align-content: center !important;
    align-items: center;
    text-align: center !important;
    @media (max-width: 900px) {
      font-size: 45px;
      height: 25%;
    }
    @media (max-width: 600px) {
      text-align: left !important;
      font-size: 40px !important;
      height: 30% !important;
      margin: 0 !important;
    }
  }
`;

const SubHeading = styled(H)`
  &.hero-subheading {
    font-size: 30px !important;
    color: #4babc0 !important;
    font-weight: 300;
    text-align: center !important;
    @media (max-width: 900px) {
      font-size: 25px !important;
    }
    @media (max-width: 600px) {
      text-align: left !important;
      font-size: 20px;
      margin: 0 !important;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Title/index.js